import { observer } from 'mobx-react-lite';
import { useCallback, useState } from 'react';

import { useStores } from 'src/components/common/root-store-provider/root-store-provider';

import CircleAnimatedProgress from '../circle-animated-progress/circle-animated-progress';
import styles from './sign-helped-step.module.scss';

const MIN_HELPED = 200_000;
const MAX_HELPED = 250_000;

function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  const randomNumber = Math.floor(Math.random() * (max - min) + min);
  return randomNumber.toLocaleString('en-US', { minimumFractionDigits: 0 }); // The maximum is exclusive and the minimum is inclusive
}

const DURATION = 5000;

const SignHelped = observer(
  ({ onNextRequest }: { onNextRequest: () => void }) => {
    const { quizStore } = useStores();
    const [eventSent, setEventSent] = useState(false);

    const sign =
      quizStore.getAstrologySing().charAt(0).toUpperCase() +
      quizStore.getAstrologySing().slice(1);

    const handleStepComplete = useCallback(
      (currentIndex: number) => {
        if (currentIndex === 4 && !eventSent) {
          setEventSent(true);
          onNextRequest();
        }
      },
      [eventSent, onNextRequest],
    );

    return (
      <div className={styles.container}>
        <h2 className={styles.heading}>
          We’ve helped {getRandomInt(MIN_HELPED, MAX_HELPED)} other {sign}{' '}
          {quizStore.gender === 0
            ? 'females'
            : quizStore.gender === 1
              ? 'males'
              : 'people'}
        </h2>
        <p className={styles.description}>
          Some understand themselves better,
          <br /> while others found their perfect partner!
          <br /> Now it’s your time to <b>change your life</b>
        </p>
        <div className={styles.progressContainer}>
          <CircleAnimatedProgress
            progressDuration={DURATION}
            handleStepComplete={handleStepComplete}
          />
          <p className={styles.loaderDescription}>Connecting...</p>
        </div>
      </div>
    );
  },
);

export default SignHelped;
